import { ExternalProgramCodes, ProductTag, RenewableSystemType } from '../enums';

export const HESLP_ALLOWED_SYSTEM_TYPES: ReadonlyArray<RenewableSystemType> = Object.freeze([
    RenewableSystemType.Solar,
    RenewableSystemType.Battery
]);

type ExternalProgramRecord = Record<string, string | undefined>;

export interface ExternalProgramSource {
    externalProgram?: string;
    extraFields?: ExternalProgramRecord;
    additionalData?: ExternalProgramRecord;
}

export function resolveExternalProgram(source?: ExternalProgramSource): string | undefined {
    if (!source) return undefined;

    return (
        source.externalProgram ||
        source.extraFields?.externalprogram ||
        source.extraFields?.externalProgram ||
        source.additionalData?.externalProgram ||
        source.additionalData?.['extraFieldsDict.externalprogram']
    );
}

export function isExternalProgram(source: ExternalProgramSource | undefined, programCode: string): boolean {
    return resolveExternalProgram(source) === programCode;
}

export function isHeslp(source?: ExternalProgramSource): boolean {
    return isExternalProgram(source, ExternalProgramCodes.HESLP);
}

export function isHeslpRenewableInterestFreeApplication(
    productTag: ProductTag,
    source?: ExternalProgramSource
): boolean {
    return productTag === ProductTag.RenewableInterestFree && isHeslp(source);
}
